/* unplugin-vue-components disabled */import { ElDrawer as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/drawer/style/css';
import { ElEmpty as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/empty/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4127612b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "width": "82%"
  },
  class: "flex items-center justify-between marginR20"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "下载任务列表", -1));
import Task from './task.vue';
import { useTaskStore } from '@/store/modules/downTask';
import { storeToRefs } from 'pinia';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const {
      clearTasks,
      setShowTask
    } = useTaskStore();
    const {
      showDrawer,
      tasksList
    } = storeToRefs(useTaskStore());
    const handleClearTasks = () => {
      ElMessageBox.confirm('确定清空下载任务列表吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearTasks();
      });
    };
    const closeShowDrawer = () => {
      setShowTask(false);
    };
    return (_ctx, _cache) => {
      const _component_el_empty = __unplugin_components_0;
      const _component_el_drawer = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_el_drawer, {
        width: "400",
        direction: "rtl",
        "append-to-body": "",
        modelValue: _unref(showDrawer),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(showDrawer) ? showDrawer.value = $event : null),
        onClose: closeShowDrawer
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _unref(tasksList).length ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "clear",
          onClick: handleClearTasks
        }, "清空列表")) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_unref(tasksList).length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(_unref(tasksList), (item, index) => {
          return _openBlock(), _createBlock(Task, {
            key: index,
            task: item
          }, null, 8, ["task"]);
        }), 128)) : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "暂无下载任务"
        }))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});